import React from 'react';
import HeaderNavigation from 'components/layout/header/HeaderNavigation';
import CareerHeaderSection from 'components/layout/team/CareerHeaderSection';
import CareerMainSection from 'components/layout/team/CareerMainSection';
import FooterMain from 'components/layout/footer/FooterMain';
import styles from 'styles/pages/CareerPage.module.sass';

/**
 * CareerPage component - The main page for the careers section.
 *
 * @returns {JSX.Element} The rendered CareerPage component.
 *
 * @example
 * // Example usage:
 * <CareerPage />
 */
const CareerPage: React.FC = () => {
  return (
    <div className={styles['career-page']}>
      <HeaderNavigation theme="dark" />
      <CareerHeaderSection />
      <CareerMainSection />
      <FooterMain />
    </div>
  );
};

export default CareerPage;